import React, { useEffect, useRef, useState } from "react";
import {
  Animated,
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  Pressable,
  TouchableOpacity,
  View,
  AppState,
  StatusBar,
} from "react-native";
import { diffClamp } from "react-native-reanimated";
import Swiper from "react-native-swiper";
import { connect, useDispatch } from "react-redux";
import CloseIcon from "@assets/svg/CloseIcon";
import DefaultCatImage from "@assets/svg/default_cat";
import ProductSkeleton from "@components/CMS/Skeleton/ProductSkeleton";
import VerticalProduct from "@components/ProductDisplayUnit/VerticalProduct";
import { actions as customerActions } from "@reducers/customerReducer";
import analytics from "@services/analytics";
import { actions as refreshActions } from "@reducers/refreshReducer";
import {
  actions as cartActions,
  getAddedProductListIds,
} from "@reducers/cartReducer";
import refreshHOC from "@utils/refreshHOC";
import strings from "@constants";
import t from "@constants/localization";
import CategoryHeader from "../../components/CMS/CategoryHeader";
import {
  CAT_NAV_EVENTS,
  CAT_NAV_SOURCES,
  ORDER_FLOW_EVENTS,
} from "../../constants/analyticsEventsCT";
import { STATE_STATUS } from "../../reducers/actionTypes";
import { getProductByCategory } from "../../services/cmsV2-api";
import CartBottomStrip from "../Home/CartBottomStrip";

const PATH = "screens/CategoryNavigation/index";

const { refresh: refreshScreenName } = strings;
const DEFAULT_PTYPE = "सभी";
const { height } = Dimensions.get("screen");
const AnimatedFlatList = Animated.createAnimatedComponent(FlatList);
const { width: screenWidth } = Dimensions.get("screen");

class CategoryNavigationScreen extends React.Component {
  state = {
    products: [],
    productCount: null,
    loading: true,
    showModal: false,
    selectedPtype: DEFAULT_PTYPE,
    currentIndex: 0,
    initialIndex: 0,
    category: null,
    subCategory: null,
    page: 1,
    loadingMore: false,
    catLayoutMap: {
      sub_categories: {},
      product_types: {},
      tab_categories: {},
    },
    activeCategoryUrl: "",

    scrollY: new Animated.Value(0),
    headerHeight: 0,
    curY: new Animated.Value(0),
    height: 0,
    subCatHeight: 0,
    checkRefresh: false,
    appState: AppState.currentState,
    ptypeMoved: false,
  };

  scrollYClamped = diffClamp(
    this.state.scrollY.current,
    0,
    this.state.headerHeight,
  );

  fetchCategory() {
    const { route, navigation, categories, categoriesStatus } = this.props;
    const { subCategory, catLayoutMap } = this.state;
    const {
      pTypeId,
      selectedCat: ac,
      selectedSubCat: asc,
      fromSalesReport,
    } = route.params;
    const selectedCat =
      Array.isArray(categories) && categories.find((cat) => cat.c_id === ac);
    const selectedSubCat = selectedCat?.sub_categories?.find(
      (subcat) => subcat.c_id === asc,
    );
    const activeSubCategory = subCategory || selectedSubCat;
    if (pTypeId) {
      const productType = selectedSubCat?.producttype || [];
      const ptypeData =
        Array.isArray(productType) &&
        productType.find((cat) => cat.c_id === pTypeId);
      const productTypeArray = [
        {
          producttype_url: activeSubCategory?.c_url, // default
        },
        ...productType,
      ];
      const ptypeIndex =
        Array.isArray(productTypeArray) &&
        productTypeArray.findIndex((cat) => cat.c_id === pTypeId);

      this.setState({
        category: selectedCat,
        subCategory: selectedSubCat,
        currentIndex: 0,
        selectedPtype: ptypeData?.producttype_url,
        initialIndex: ptypeIndex,
      });
    } else {
      this.setState({
        activeCategoryUrl: activeSubCategory?.c_url,
      });
    }
  }

  componentDidMount() {
    const { route, navigation, categories, categoriesStatus } = this.props;
    if (categoriesStatus === STATE_STATUS.FETCHED) {
      this.fetchCategory();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.categoriesStatus === STATE_STATUS.FETCHING &&
      this.props.categoriesStatus === STATE_STATUS.FETCHED
    ) {
      this.fetchCategory();
    }
  }

  scrollRef;

  pTypeScrollRef;

  tabScrollRef;

  changeCatModal = ({ activeCategoryId }) => {
    const { showModal, catLayoutMap } = this.state;
    const { categories = [] } = this.props;
    return (
      <Modal
        animationType="slide"
        transparent={true}
        visible={showModal}
        statusBarTranslucent
        navigationBarTranslucent
        onRequestClose={() =>
          this.setState({
            showModal: false,
          })
        }
      >
        <View style={{ flex: 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <View
            style={{
              backgroundColor: "white",
              width: "100%",
              marginTop: "auto",
              borderTopRightRadius: 28,
              borderTopLeftRadius: 28,
              overflow: "hidden",
              maxHeight: "80%",
            }}
          >
            <View style={{ paddingBottom: 60 }}>
              <View
                style={{
                  flexDirection: "row",
                  marginVertical: 20,
                  marginHorizontal: 18,
                }}
              >
                <Text
                  style={{
                    color: "rgba(0, 0, 0, 1)",
                    fontSize: 16,
                    fontWeight: "bold",
                    flex: 1,
                  }}
                >
                  {t(`${PATH}/buyByCategory`)}
                </Text>
                <TouchableOpacity
                  onPress={() =>
                    this.setState({
                      showModal: false,
                    })
                  }
                >
                  <CloseIcon />
                </TouchableOpacity>
              </View>
              <ScrollView
                ref={(ref) => {
                  this.tabScrollRef = ref;
                }}
              >
                {categories.map((item, index) => {
                  return (
                    <Pressable
                      onLayout={({
                        nativeEvent: {
                          layout: { x: X, y, width, height },
                        },
                      }) => {
                        this.setState({
                          catLayoutMap: {
                            ...catLayoutMap,
                            tab_categories: {
                              ...catLayoutMap.tab_categories,
                              [item.c_id]: y,
                            },
                          },
                        });
                      }}
                      key={item.c_id}
                      onPress={() => {
                        this.setState({
                          category: item,
                          subCategory: item?.sub_categories[0],
                          showModal: false,
                          activeCategoryUrl: item?.sub_categories[0]?.c_url,
                          selectedPtype: DEFAULT_PTYPE,
                          initialIndex: 0,
                          currentIndex: 0,
                        });
                        this.state.curY.setValue(0);
                        setTimeout(() => {
                          this.scrollToSelectedProductCategory({ x: 0 });
                          this.scrollToSelectedSubCategory({ x: 0 });
                        }, 200);
                        analytics.trackEvent(
                          CAT_NAV_EVENTS.PRIMARY_CAT_CLICKED,
                          {
                            source: CAT_NAV_SOURCES.CAT_IN,
                            cat: item.name_hi,
                            sub:
                              item.sub_categories &&
                              item.sub_categories[0] &&
                              item.sub_categories[0].name_hi,
                            ptype: DEFAULT_PTYPE,
                          },
                        );
                      }}
                    >
                      <View
                        style={[
                          styles.categoriesItem,
                          {
                            backgroundColor:
                              item.c_id === activeCategoryId
                                ? "#f7f7f7"
                                : "#fff",
                          },
                        ]}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Image
                            source={{ uri: item.c_img }}
                            style={styles.categoriesItemImage}
                            resizeMode="contain"
                          />
                          <View
                            style={{
                              marginLeft: 20,
                              flex: 1,
                              alignSelf: "flex-start",
                            }}
                          >
                            <Text style={styles.categoriesItemTitle}>
                              {item.name_hi}
                            </Text>
                            <Text
                              numberOfLines={2}
                              ellipsizeMode="tail"
                              style={{
                                color: "rgba(0, 0, 0, 0.56)",
                              }}
                            >
                              {item.cat_slug}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </Pressable>
                  );
                })}
              </ScrollView>
            </View>
          </View>
        </View>
      </Modal>
    );
  };

  InfiniteFlatListItem = (item, index) => {
    return <VerticalProduct key={`p${index}`} data={item} index={index} />;
  };

  scrollToSelectedTabCategory = ({ x = 0, y = 800 }) => {
    const { category, catLayoutMap } = this.state;
    const { route } = this.props;
    const { selectedCat: ac } = route.params;
    const activeCategory = category || ac;
    this.tabScrollRef?.scrollTo({
      x,
      y: catLayoutMap.tab_categories[activeCategory.c_id]
        ? catLayoutMap.tab_categories[activeCategory.c_id]
        : 0,
      animated: true,
    });
  };

  scrollToSelectedProductCategory = ({ x = 0, y = 0, source }) => {
    console.log("------- ptype scroll :( --------");
    this.pTypeScrollRef?.scrollTo({
      x,
      y,
      animated: true,
    });
  };

  scrollToSelectedSubCategory = ({ x = null }) => {
    const { catLayoutMap, subCategory } = this.state;
    const { route } = this.props;
    const { selectedSubCat: asc } = route.params;
    const activeSubCategory = subCategory || asc;
    this.scrollRef?.scrollTo({
      x:
        x !== null
          ? x
          : catLayoutMap.sub_categories[activeSubCategory?.c_id]
            ? catLayoutMap.sub_categories[activeSubCategory?.c_id] - 10
            : 0,
      animated: true,
    });
  };

  SUBP = ({
    sub_categories = [],
    producttype,
    activeSubCategoryId,
    activeCategory,
    activeSubCategory,
  }) => {
    const { selectedPtype, catLayoutMap } = this.state;

    return (
      <View
        onLayout={({ nativeEvent }) =>
          this.setState({ subCatHeight: nativeEvent.layout.height })
        }
        style={{
          backgroundColor: "#fff",
        }}
      >
        <View
          style={{
            display: sub_categories.length > 0 ? "flex" : "none",
            paddingVertical: 10,
            borderWidth: 1,
            borderColor: "rgba(0, 0, 0, 0.1)",
          }}
        >
          <ScrollView
            onContentSizeChange={() => {
              this.scrollToSelectedSubCategory({});
            }}
            ref={(ref) => (this.scrollRef = ref)}
            showsHorizontalScrollIndicator={false}
            horizontal={true}
            contentContainerStyle={{
              paddingTop: 8,
            }}
          >
            {Array.isArray(sub_categories) &&
              sub_categories.map((x, i) => (
                <Pressable
                  onLayout={({
                    nativeEvent: {
                      layout: { x: X, y, width, height },
                    },
                  }) => {
                    this.setState({
                      catLayoutMap: {
                        ...catLayoutMap,
                        sub_categories: {
                          ...catLayoutMap.sub_categories,
                          [x.c_id]: X,
                        },
                      },
                    });
                  }}
                  key={`sub-cat${i}`}
                  onPress={() => {
                    this.state.curY.setValue(0);
                    this.setState(
                      {
                        selectedPtype: DEFAULT_PTYPE,
                        subCategory: x,
                        activeCategoryUrl: x.c_url,
                        initialIndex: 0,
                        currentIndex: 0,
                      },
                      () => {
                        this.swiperRef.scrollTo(0, true);
                      },
                    );
                    this.scrollToSelectedSubCategory({
                      x: this.state.catLayoutMap.sub_categories[x.c_id] - 10,
                    });
                    analytics.trackEvent(CAT_NAV_EVENTS.PRIMARY_CAT_CLICKED, {
                      source: CAT_NAV_SOURCES.CAT_IN,
                      cat: activeCategory.name_hi,
                      sub: x.name_hi,
                      ptype: selectedPtype,
                    });
                  }}
                >
                  <View
                    key={i}
                    style={{
                      flexDirection: "row",
                      alignItems: "flex-end",
                      height: 44,
                      marginHorizontal: 6,
                      borderWidth: 1,
                      borderColor:
                        x.c_id === activeSubCategoryId
                          ? "red"
                          : "rgba(0, 0, 0, 0.1)",
                      paddingRight: 6,
                      borderRadius: 4,
                    }}
                  >
                    {x.c_img ? (
                      <Image
                        source={{ uri: x.c_img }}
                        style={{
                          height: 36,
                          width: 36,
                          marginRight: 5,
                        }}
                        resizeMode="contain"
                      />
                    ) : (
                      <DefaultCatImage width={36} height={36} />
                    )}
                    <Text
                      numberOfLines={2}
                      ellipsizeMode="tail"
                      style={{
                        color: "rgba(0, 0, 0, 0.56)",
                        fontSize: 12,
                        alignSelf: "center",
                        maxWidth: 62,
                        borderWidth: 0,
                      }}
                    >
                      {x.name_hi}
                    </Text>
                  </View>
                </Pressable>
              ))}
          </ScrollView>
        </View>
        <View
          style={{
            paddingVertical: 10,
            borderWidth: 1,
            borderColor: "rgba(0, 0, 0, 0.1)",
            borderTopWidth: 0,
          }}
        >
          <ScrollView
            ref={(ref) => (this.pTypeScrollRef = ref)}
            onContentSizeChange={() =>
              this.scrollToSelectedProductCategory({
                source: "on content size",
              })
            }
            showsHorizontalScrollIndicator={false}
            horizontal={true}
          >
            <Pressable
              onPress={() => {
                this.state.curY.setValue(0);
                this.setState({
                  selectedPtype: DEFAULT_PTYPE,
                });
                analytics.trackEvent(CAT_NAV_EVENTS.PTYPE_CAT_CLICKED, {
                  cat: activeCategory.name_hi,
                  sub: activeSubCategory.name_hi,
                  ptype: DEFAULT_PTYPE,
                });
                this.scrollToSelectedProductCategory({
                  x: 0,
                });
                this.swiperRef.scrollTo(0, true);
              }}
            >
              <View
                style={{
                  marginHorizontal: 6,
                  borderWidth: 1,
                  borderColor:
                    selectedPtype === DEFAULT_PTYPE
                      ? "red"
                      : "rgba(0, 0, 0, 0.1)",
                  backgroundColor:
                    selectedPtype === DEFAULT_PTYPE
                      ? "rgba(228,0,70,0.05)"
                      : "white",
                  borderRadius: 100,
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 8,
                }}
              >
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  style={{
                    color: "rgba(0, 0, 0, 0.56)",
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  {DEFAULT_PTYPE}
                </Text>
              </View>
            </Pressable>
            {producttype &&
              producttype.map((x, i) => {
                return (
                  <Pressable
                    onLayout={({
                      nativeEvent: {
                        layout: { x: X, y, width, height },
                      },
                    }) => {
                      this.setState({
                        catLayoutMap: {
                          ...catLayoutMap,
                          product_types: {
                            ...catLayoutMap.product_types,
                            [x?.producttype_url]: X,
                          },
                        },
                      });
                    }}
                    key={`sub-cat${i}`}
                    onPress={() => {
                      this.state.curY.setValue(0);
                      this.setState({
                        selectedPtype: x?.producttype_url,
                        activeCategoryUrl: x?.producttype_url,
                      });
                      this.swiperRef.scrollTo(i + 1, true);

                      // this.fetchProducts({ c_url: x.producttype_url });
                      if (i === 0) {
                        this.scrollToSelectedProductCategory({
                          x: 0,
                        });
                      } else {
                        this.scrollToSelectedProductCategory({
                          x:
                            this.state.catLayoutMap.product_types[
                              producttype[i - 1]?.producttype_url
                            ] - 10,
                        });
                      }
                      analytics.trackEvent(CAT_NAV_EVENTS.PTYPE_CAT_CLICKED, {
                        cat: activeCategory.name_hi,
                        sub: activeSubCategory.name_hi,
                        ptype: x.producttype_name_hi,
                      });
                    }}
                  >
                    <View
                      key={i}
                      style={{
                        marginHorizontal: 6,
                        borderWidth: 1,
                        borderColor:
                          selectedPtype === x?.producttype_url
                            ? "red"
                            : "rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          selectedPtype === x?.producttype_url
                            ? "rgba(228,0,70,0.05)"
                            : "white",
                        borderRadius: 100,
                        justifyContent: "center",
                        alignItems: "center",
                        paddingHorizontal: 10,
                        paddingVertical: 8,
                      }}
                    >
                      <Text
                        numberOfLines={1}
                        ellipsizeMode="tail"
                        style={{
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        {x.producttype_name_hi}
                      </Text>
                    </View>
                  </Pressable>
                );
              })}
          </ScrollView>
        </View>
      </View>
    );
  };

  trackEvent = (type, data) => {
    const { currentCartSkuIds } = this.props;
    switch (type) {
      case ORDER_FLOW_EVENTS.PRODUCT_CLICKED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_CLICKED, {
          CAT_NAV: "yes",
          ...currentCartSkuIds,
          ...data,
        });
        return;
      case ORDER_FLOW_EVENTS.PRODUCT_ADDED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, {
          CAT_NAV: "yes",
          ...currentCartSkuIds,
          ...data,
        });
        return;
      case ORDER_FLOW_EVENTS.PRODUCT_REMOVED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, {
          CAT_NAV: "yes",
          ...currentCartSkuIds,
          ...data,
        });
        return;
      case ORDER_FLOW_EVENTS.PRODUCT_BUNDLED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_BUNDLED, {
          CAT_NAV: "yes",
          ...currentCartSkuIds,
          ...data,
        });
    }
  };

  handleScroll = Animated.event(
    [
      {
        nativeEvent: {
          contentOffset: { y: this.state.scrollY.current },
        },
      },
    ],
    {
      useNativeDriver: true,
    },
  );

  render() {
    const { products, loading, category, subCategory } = this.state;
    const { route, navigation, categories } = this.props;
    const {
      selectedCat: ac,
      selectedSubCat: asc,
      sharingTemplate = {},
      fromSalesReport,
    } = route.params;
    const selectedCat =
      (Array.isArray(categories) &&
        categories.find((cat) => cat.c_id === ac)) ||
      {};
    const selectedSubCat = selectedCat?.sub_categories?.find(
      (subcat) => subcat.c_id === asc,
    );
    const activeCategory = category || selectedCat || {};
    const activeSubCategory = subCategory || selectedSubCat || {};
    const activeCategoryId = activeCategory.c_id;
    const activeSubCategoryId = activeSubCategory.c_id;
    const { name_hi, sub_categories } = activeCategory;
    const { producttype = [] } = activeSubCategory;

    const headerDistance = Animated.diffClamp(
      this.state.curY,
      0,
      this.state.subCatHeight,
    ).interpolate({
      inputRange: [0, 1],
      outputRange: [0, -1],
    });

    const productTypeArray = [
      {
        producttype_url: activeSubCategory.c_url, // default
      },
      ...producttype,
    ];

    return (
      <SafeAreaView style={styles.container}>
        {this.changeCatModal({ activeCategoryId })}
        <StatusBar
          backgroundColor="transparent"
          barStyle="dark-content"
          animated={true}
        />
        <Animated.View
          style={{
            flexBasis:
              this.props.cartItems.length > 0 && this.state.selectedContact
                ? "94%"
                : "100%",
          }}
        >
          <Swiper
            loadMinimal={true}
            loadMinimalSize={1}
            loop={false}
            index={this.state.initialIndex}
            showsPagination={false}
            ref={(el) => (this.swiperRef = el)}
            onScroll={(e) => {
              const {
                nativeEvent: {
                  contentOffset: { x, y },
                },
              } = e;
              const prevIndex = this.state.currentIndex;
              const scrollDirection = x - screenWidth * prevIndex;
              const amountScrolledAbs = Math.abs(x - screenWidth * prevIndex);
              const scrollPercent =
                (amountScrolledAbs / screenWidth).toFixed(2) * 100;
              const updatedIndex =
                scrollPercent > 50
                  ? scrollDirection > 0
                    ? prevIndex + 1
                    : prevIndex - 1
                  : prevIndex;
              if (updatedIndex !== prevIndex) {
                this.state.curY.setValue(0);
              }
              if (fromSalesReport) {
                const scrollI =
                  this.state.initialIndex === 0
                    ? 0
                    : this.state.initialIndex - 1;
                this.scrollToSelectedProductCategory({
                  x:
                    this.state.catLayoutMap.product_types[
                      productTypeArray[scrollI]?.producttype_url
                    ] - 10,
                });
                this.props.route.params.fromSalesReport = false;
              }
            }}
            onIndexChanged={(index) => {
              this.state.curY.setValue(0);

              // this.setState((state) => {
              //   return {
              //     ...state,
              //     currentIndex: index,
              //   };
              // });
              this.setState((state) => {
                if (index === 0) {
                  return {
                    ...state,
                    currentIndex: index,
                    selectedPtype: DEFAULT_PTYPE,
                  };
                } else {
                  return {
                    ...state,
                    currentIndex: index,
                    selectedPtype: productTypeArray[index]?.producttype_url,
                  };
                }
              });
              const scrollI = index == 0 ? 0 : index - 1;
              this.scrollToSelectedProductCategory({
                x:
                  this.state.catLayoutMap.product_types[
                    productTypeArray[scrollI]?.producttype_url
                  ] - 10,
              });
            }}
          >
            {productTypeArray.map((x, index) => (
              <Animated.View
                key={index}
                style={{
                  flex: 1,
                }}
              >
                <ListContainer
                  item={x}
                  scrollY={this.state.curY}
                  onScroll={Animated.event(
                    [
                      {
                        nativeEvent: {
                          contentOffset: { y: this.state.curY },
                        },
                      },
                    ],
                    { useNativeDriver: true },
                  )}
                  contentContainerStyle={[
                    {
                      paddingTop: this.state.height + 56,
                    },
                  ]}
                  currentIndex={this.state.currentIndex}
                  refreshCart={() => {
                    if (this?.props?.selectedContact)
                      this?.props?.refreshCart(this?.props?.selectedContact);
                  }}
                />
              </Animated.View>
            ))}
          </Swiper>
        </Animated.View>

        <View
          style={{
            position: "absolute",
            width: "100%",
            top: 0,
            zIndex: 2,
          }}
        >
          <CategoryHeader
            background={{
              backgroundColor: "#f7f7f7",
            }}
            showArrow={true}
            onTitleClick={() => {
              this.setState({
                showModal: true,
              });
            }}
            title={name_hi}
            {...{ navigation }}
            showWhatsappLogo={false}
            isStatusBarTranslucent={true}
          />
        </View>

        <Animated.View
          style={{
            top: 56,
            transform: [
              {
                translateY: headerDistance,
              },
            ],
            position: "absolute",
            width: "100%",
            zIndex: 1,
          }}
          onLayout={({ nativeEvent }) =>
            this.setState({ height: nativeEvent.layout.height })
          }
        >
          {this.SUBP({
            producttype,
            activeSubCategoryId,
            sub_categories,
            activeCategory,
            activeSubCategory,
          })}
        </Animated.View>

        {this.props.selectedContact ? (
          <CartBottomStrip
            bottom={{ bottom: 0 }}
            orderClick={() => {
              this.props.navigation.push("ConfirmOrder");
              analytics.trackEvent(ORDER_FLOW_EVENTS.CHECKOUT_STARTED, {
                screen: "CATEGORY_NAVIGATION",
                cart_value: this.props.cartDetails.total,
                cart_quantity: Array.isArray(this.props.cartItems)
                  ? this.props.cartItems.reduce(
                      (acc, curr) => (acc += curr.quantity),
                      0,
                    )
                  : "",
              });
            }}
            onCrossClick={() => {
              this.props.setSelectedContact(false);
              analytics.trackEvent(ORDER_FLOW_EVENTS.CX_CANCELLED);
            }}
            total={this.props.cartDetails.total}
            item={this.props.cartItems.length}
            name={this.props.selectedContact.user_name}
          />
        ) : null}
      </SafeAreaView>
    );
  }
}

const mstp = ({ configReducer, user, cart, customer, refresh }) => {
  return {
    categories: configReducer.fullCategoryList,
    categoriesStatus: configReducer.status,
    currentCartSkuIds: getAddedProductListIds(cart),
    selectedContact: customer.selectedContact,
    cartDetails: cart.cartDetails,
    cartItems: cart.cartItems,
    cart,
    juspayInitiateData: configReducer.juspayInitiateData,
    refresh,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setSelectedCustomer: (data) =>
    dispatch(customerActions.setSelectedContact(data)),
  setSelectedContact: () => dispatch(customerActions.setSelectedContact(false)),
  setRefreshTimeStamp: () =>
    dispatch(refreshActions.setRefreshTimeStamp("CatNav")),
  resetRefreshTimeStamp: () =>
    dispatch(refreshActions.resetRefreshTimeStamp("CatNav")),
  refreshCart: (selectedContact) => {
    if (selectedContact) {
      dispatch(cartActions.viewCartLiteRequest(selectedContact));
    }
  },
});

export default connect(
  mstp,
  mapDispatchToProps,
)(refreshHOC(refreshScreenName.catnav)(CategoryNavigationScreen));

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  categoriesWrapper: {
    backgroundColor: "rgb(247,247,247)",
    paddingBottom: 25,
  },
  categoriesTitle: {
    color: "rgba(0, 0, 0, 0.86)",
    fontWeight: "bold",
    fontSize: 20,
    lineHeight: 30,
    paddingBottom: 10,
  },
  categoriesRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: -8,
  },
  categoriesItem: {
    backgroundColor: "#fff",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0, 0, 0, 0.1)",
    padding: 12,
  },
  categoriesItemImage: {
    height: 70,
    width: 70,
  },
  categoriesItemTitle: {
    color: "rgb(0, 0, 0)",
    fontSize: 16,
    paddingTop: 12,
    paddingBottom: 4,
    fontWeight: "bold",
  },
});

const ListContainer = ({
  item,
  contentContainerStyle,
  onScroll,
  refreshCart = () => {},
}) => {
  const flatListRef = useRef();

  useEffect(() => {
    if (item?.producttype_url) {
      fetchProducts({ c_url: item?.producttype_url });
    }
  }, [item?.producttype_url]);

  const [products, setProducts] = useState([]);
  const [productCount, setProductCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);

  const fetchProducts = ({ c_url, limit = 10, offset = 0 }) => {
    setLoading(true);
    getProductByCategory({ category_url: c_url, limit, offset })
      .then(({ data }) => {
        setProducts(data.result);
        setProductCount(data.count);
        setPage(1);
        setLoading(false);
      })
      .catch((x) => {
        setLoading(false);
      });
    refreshCart();
  };

  const fetchMore = () => {
    if (loading) {
      return;
    }
    if (productCount !== null && page * 10 > productCount) {
      return;
    }
    setLoadMore(true);
    getProductByCategory({
      category_url: item?.producttype_url,
      limit: 10,
      offset: page * 10,
    })
      .then(({ data }) => {
        setProducts((p) => [...p, ...data.result]);
        setProductCount(data.count);
        setPage((p) => p + 1);
        setLoadMore(false);
      })
      .catch((x) => {
        setLoadMore(false);
      });
  };

  const InfiniteFlatListFooter = () => {
    if (loadMore && !loading) {
      return (
        <>
          <ProductSkeleton />
          <ProductSkeleton />
        </>
      );
    } else return null;
  };

  if (loading) {
    return (
      <View style={contentContainerStyle}>
        <ProductSkeleton />
        <ProductSkeleton />
        <ProductSkeleton />
      </View>
    );
  }

  return (
    <AnimatedFlatList
      ref={flatListRef}
      keyExtractor={(item) => `${item.sku_id}`}
      style={{
        flex: 1,
      }}
      onScroll={onScroll}
      ListFooterComponent={InfiniteFlatListFooter}
      onEndReached={fetchMore}
      onEndReachedThreshold={0.1}
      maxToRenderPerBatch={30}
      renderItem={({ item, index }) => {
        return (
          <VerticalProduct
            key={`p${index}`}
            data={item}
            index={index}
            // trackEvent={this.trackEvent}
          />
        );
      }}
      data={products}
      initialNumToRender={10}
      contentContainerStyle={contentContainerStyle}
      ListEmptyComponent={() => (
        <ListEmptyComponent loading={loading} products={products} />
      )}
    />
  );
};

const ListEmptyComponent = ({ loading = false, products = [] }) =>
  !loading && products.length === 0 ? (
    <View
      style={{
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 36,
        marginHorizontal: 24,
      }}
    >
      <Image
        style={{
          width: 120,
          height: 120,
          marginBottom: 24,
        }}
        source={require("../../assets/svg/PlacesNoResults.webp")}
      />
      <Text fontType="head2">{t(`${PATH}/noProductFound`)}</Text>
    </View>
  ) : (
    <></>
  );
